import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store.type';
import * as css from './CoverContent.css';
import EventDateTime from '../components/EventDateTime/EventDateTime';
import {defaultImage} from '../../../assets/symbols/images/defaultImage';

function CoverContent() {
    const event = useSelector((s: RootState) => s.eTicket.data?.event);
    if(!event)
        return null;

    const venue = [event.location, event.address].filter(Boolean).join(' • ');

    return (
        <css.content data-cy="ticket-cover-content">
            <css.poster
                className={event.image ? '' : 'fallback'}
                $bgColor={event.image ? event.imageColors?.[0] : undefined}>
                {/* fetchpriority via spread: React 18 types/lint don't know the lowercase
                    attribute yet (camelCase fetchPriority is React 19+) */}
                <img src={event.image || defaultImage} alt={event.title} decoding="async" {...({fetchpriority: 'high'} as object)} />
            </css.poster>
            <css.details>
                <css.title>{event.title}</css.title>
                <EventDateTime event={event} />
                {venue && <css.venue title={venue}>{venue}</css.venue>}
            </css.details>
        </css.content>
    );
}

export default CoverContent;
